// import {
// 	BASE_URL,
// 	BASE_USER_INFO,
// 	MAP_LOADED,
// 	CURRENT_RID,
// 	CURRENT_RINFO,
// 	SETTING_MAP_SHOW
// } from './mutations-type.js'
// 使用常量替代 Mutation 事件类型
import * as type from './mutations-type.js'
import Bus from '@/assets/js/vueBus.js'
import Vue from 'vue'
import axios from 'axios'
import Outil from '@/assets/js/utils.js'

export default {
  [type.BASE_URL] (state, {
    urlInfo
  }) {
    state.baseUrl = urlInfo
    const { gatewayDeviceExtraUrl, playoutServerName, userGroupUrl, userAuthUrl } = urlInfo
    // 用于tvu-common-components的传参
    Vue.prototype.$TVU = {
      http: axios,
      gateway: gatewayDeviceExtraUrl.includes('http') ? gatewayDeviceExtraUrl : `${location.protocol}//${gatewayDeviceExtraUrl}`,
      serverName: playoutServerName,
      userGroup: userGroupUrl,
      userAuthUrl: userAuthUrl,
      session: Outil.getSession()
    }

    if (!state.webrtc) {
      state.webrtc = new Window.RtcClient()
      const https = window.location.protocol.includes('https')
      https ? state.webrtc.init(urlInfo.rtcSslUrl, null, { loginName: Date.now() + 'x' }) : state.webrtc.init(urlInfo.rtcUrl, null, { loginName: Date.now() + 'x' })
    }
    setTimeout(() => {
      Bus.$emit('createPageRequest')
    }, 100)
  },
  [type.BASE_USER_INFO] (state, {
    userInfo
  }) {
    state.baseUserInfo = userInfo
    Bus.$emit('siginalUrl')
  },
  [type.MAP_LOADED] (state, data) {
    state.mapLoaded = data
  },
  [type.CURRENT_RID] (state, data) {
    state.currentRid = data
  },
  [type.CURRENT_RINFO] (state, data) {
    state.currentRInfo = data
  },
  [type.SETTING_MAP_SHOW] (state, data) {
    state.settingMapShow = data
  },
  [type.DEVICELIST_VOLUMECHARTDATA] (state, data) {
    state.deviceListVolumeChartData = data
  },
  [type.DEVICELIST_SLOTINFODATA] (state, data) {
    state.deviceListSlotInfoData = data
  },
  [type.DEVICELIST_RECEIVERDATADATA] (state, data) {
    state.deviceListReceiverDataData = data
  },
  [type.DEVICELIST_CURRENTRINFODATA] (state, data) {
    state.deviceListCurrentRInfoData = data
  },
  [type.DEVICELIST_SETINFODATA] (state, data) {
    state.deviceListSetInfoData = data
  },
  [type.CHANGE_SOURCECONTROL_TAB] (state, data) {
    state.sourceControlTab = data
  },
  [type.CHANGE_SOURCESize] (state, data) {
    state.showDeviceSize = data
  },
  [type.CHANGE_RecevierSize] (state, data) {
    state.showRecevierSize = data
  }
}
